import TagAlertValue from '@/modules/core/models/TagAlertValue'

export default class HealthConfigurationTags {
  copayAlert: TagAlertValue
  customDateAlert: TagAlertValue
  anotherInsuranceAlert?: TagAlertValue
  anotherInsuranceNotHolderAlert?: TagAlertValue
  anotherInternationalInsuranceAlert?: TagAlertValue
  anotherInternationalInsuranceNotHolderAlert?: TagAlertValue
  holderAlert?: TagAlertValue
  personalDataAlert?: TagAlertValue
  personalDataInsuredAlert?: TagAlertValue
  contactDataAlert?: TagAlertValue
  contactDataInsuredAlert?: TagAlertValue
  bankCopayAlert?: TagAlertValue

  constructor(data: any) {
    const raterTags = data['health-pricing']
    const hiringTags = data['health-contracting']
    this.copayAlert = new TagAlertValue(raterTags['health-pricing-copay'])
    this.customDateAlert = new TagAlertValue(raterTags['health-pricing-startdate'])

    if (hiringTags) {
      this.anotherInsuranceAlert = new TagAlertValue(hiringTags['health-contracting-another'])
      this.anotherInsuranceNotHolderAlert = new TagAlertValue(
        hiringTags['health-contracting-another-company-insured']
      )
      if (hiringTags['health-international-contracting-another']) {
        this.anotherInternationalInsuranceAlert = new TagAlertValue(
          hiringTags['health-international-contracting-another']
        )
      }
      if (hiringTags['health-international-contracting-another-company-insured']) {
        this.anotherInternationalInsuranceNotHolderAlert = new TagAlertValue(
          hiringTags['health-international-contracting-another-company-insured']
        )
      }
      this.holderAlert = new TagAlertValue(hiringTags['health-contracting-identification'])
      this.personalDataAlert = new TagAlertValue(hiringTags['health-contracting-personal-data'])
      this.personalDataInsuredAlert = new TagAlertValue(
        hiringTags['health-contracting-personal-data-insured']
      )
      this.contactDataAlert = new TagAlertValue(hiringTags['health-contracting-personal-data-2'])
      this.contactDataInsuredAlert = new TagAlertValue(
        hiringTags['health-contracting-contact-insured']
      )
      this.bankCopayAlert = new TagAlertValue(hiringTags['health-contracting-bank'])
    }
  }
}
